import {MapSuggestItemSchema}from'./suggest-item.js';import {z}from'zod';const o=z.array(MapSuggestItemSchema);export{o as MapSuggestSearchResponseSchema};